var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.50168C7.63215 6.12602 7.89298 5.80925 8.2363 5.60748C8.57962 5.40571 8.98327 5.33195 9.37576 5.39928C9.76825 5.4666 10.1243 5.67065 10.3807 5.9753C10.6372 6.27995 10.7775 6.66554 10.7769 7.06376C10.7769 8.18792 9.09069 8.75 9.09069 8.75M9.11243 11H9.11993M5.25 14V15.7516C5.25 16.1513 5.25 16.3511 5.33192 16.4537C5.40317 16.543 5.5112 16.5949 5.6254 16.5948C5.75672 16.5946 5.91275 16.4698 6.22482 16.2201L8.01391 14.7889C8.37939 14.4965 8.56213 14.3503 8.76561 14.2463C8.94615 14.1541 9.13832 14.0867 9.33691 14.0459C9.56075 14 9.79477 14 10.2628 14H12.15C13.4101 14 14.0402 14 14.5215 13.7548C14.9448 13.539 15.289 13.1948 15.5048 12.7715C15.75 12.2902 15.75 11.6601 15.75 10.4V6.35C15.75 5.08988 15.75 4.45982 15.5048 3.97852C15.289 3.55516 14.9448 3.21095 14.5215 2.99524C14.0402 2.75 13.4101 2.75 12.15 2.75H5.85C4.58988 2.75 3.95982 2.75 3.47852 2.99524C3.05516 3.21095 2.71095 3.55516 2.49524 3.97852C2.25 4.45982 2.25 5.08988 2.25 6.35V11C2.25 11.6975 2.25 12.0462 2.32667 12.3323C2.53472 13.1088 3.1412 13.7153 3.91766 13.9233C4.20378 14 4.55252 14 5.25 14Z",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestionIcon);
export default __webpack_public_path__ + "static/media/message-question-icon.3d6ca0c4.svg";
export { ForwardRef as ReactComponent };